import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Table from '@mui/material/Table';
import { useDispatch } from 'react-redux';

import { codelistProvider, ComponentLoader } from 'components';
import PaginationRow from 'components/atoms/GefMui/PaginationRow';
import { codelists } from 'constants/codelists';
import fetch from 'features/common/fetch';
import { handlePagination, handleReload, loadMore } from 'features/views/usersSubordinate/actions';

import SubordinateUsersTableBody from './TableBody';
import SubordinateUsersTableHead from './TableHead';

export const SubordinateUsersTable = ({ contextUser }) => {
	const dispatch = useDispatch();

	const handleOnReload = useCallback(() => {
		dispatch(handleReload());
	}, [dispatch]);

	const handleLoadMore = useCallback(() => {
		dispatch(loadMore());
	}, [dispatch]);

	const handlePaginationClick = useCallback(
		(e, page) => {
			dispatch(handlePagination(page - 1));
		},
		[dispatch],
	);

	const fetchStorePath = `${fetch.constants.urls.userList}.${contextUser ? contextUser.login : 'root'}`;

	return (
		<ComponentLoader fetchStorePath={fetchStorePath} onReload={handleOnReload}>
			<Grid container>
				<Grid size={12}>
					<Table size="small">
						<SubordinateUsersTableHead />
						<SubordinateUsersTableBody />
						<PaginationRow
							fetchStorePath={fetchStorePath}
							onLoadNext={handleLoadMore}
							onPaginationClick={handlePaginationClick}
						/>
					</Table>
				</Grid>
			</Grid>
		</ComponentLoader>
	);
};

SubordinateUsersTable.propTypes = {
	contextUser: PropTypes.object,
};

export default codelistProvider(codelists.taskTypes, 'taskTypesCodelist')(SubordinateUsersTable);
